import React from 'react'; 
import { Link } from 'react-router-dom';
import HeaderNav from '../components/HeaderNav';
import PageIntro from '../components/PageIntro';
import ServicePanels from '../components/ServicePanels';

function ServTrain() {
    const servURL = "../services";
    const contURL = "../contact";
    return (
      <div id="mainContent">
        <div id="navHolder">
          <HeaderNav pageTitle="services" />
        </div>
        <div id = "intro">
            <h1>Training</h1>
            <PageIntro pageTitle="Training" output="intro"/>
        </div>
        <div id="servicesContent">
            <ServicePanels page="TRAIN" mode="rows" />
        </div>
        <div id="servInfo">
      <div className = "returnNav">
        <h3>
          <Link to={servURL} reloadDocument className="servCTA">&#60; BACK TO SERVICES</Link>
        </h3>
      </div>
      <div className = "contactText">
        If you are interested in any of the above services then don't hesitate to <Link to={contURL} reloadDocument className="contactCTA">contact us</Link> and we can arrange a meeting to discuss how we can help.
      </div>
    </div>
      </div>
    );
  }
export default ServTrain;
